import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine clsx + tailwind-merge to dedupe conflicting Tailwind classes.
 * Standard shadcn utility — every component uses it.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
